import { Dispatch, FC, SetStateAction } from 'react';
import { AssignmentItemList } from '../../models/Assignment';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

interface Props {
  assignment: AssignmentItemList;
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  cancelAssignmentHandler: (assignmentId: string) => void;
}

export const AssignmentDeleteModal: FC<Props> = ({ assignment, setVisible, visible, cancelAssignmentHandler }) => {
  const cancelAssignment = () => {
    cancelAssignmentHandler(assignment.id);
    setVisible(false);
  };

  const footer = () => {
    return (
      <div className="flex justify-content-between w-full">
        <Button outlined className="border-none" label="Cancel" onClick={() => setVisible(false)} />
        <Button label="Delete" onClick={() => cancelAssignment()} />
      </div>
    );
  };

  return (
    <Dialog footer={footer()} className="w-3" onHide={() => setVisible(false)} visible={visible} header="Delete">
      <div>
        <div className="field mx-auto col-12">
          <div>
            <div className="flex justify-content-center my-3">
              <i className="nc_icon-nc_trash icon-md text-primary" />
            </div>
            <h3 className="text-center font-semibold">Delete assignment?</h3>
            <p className="w-8 text-center mx-auto" style={{ fontFamily: 'Poppins' }}>
              This action will permanently remove the assignment along with all associated data, including student
              progress and related records. This cannot be undone.
            </p>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
